import {ssrGetListGames} from '~/graphql/operations/game/games-query.generated';
import * as Types from '../../graphql/types';

// Extending the GameCollection using intersection
type ExtendedGameCollection = Types.GameCollection & {
  query?: any;
};


async function getListGame(
  locale?: string,
  skip: Types.GameCollection['skip'] = 0,
  limit: Types.GameCollection['limit'] = 10,
  query: any = {},
  sort: any = 'releaseDate_DESC',
  calendarReel?: {
    from: string;
    to: string;
  }
) {
  let dataResult: any = [];
  const newQuery: any = {AND: [], OR: []};
  newQuery['AND'] = [];
  if (!!query?.platform?.length && !!query?.genre?.length) {
    newQuery['AND'] = query?.platform.flatMap((d: string) => ({
      platform_contains_some: d,
      genre_contains_some: query?.genre,
    }));
  } else {
    if (query?.platform?.length) newQuery['AND'].push({platform_contains_some: query?.platform});
    if (query?.genre?.length) newQuery['AND'].push({genre_contains_some: query?.genre});
  }

  if (query?.title) {
    const orTitle = query?.title.map((item: string) => {
      return {brand: {title_contains: item}};
    });
    newQuery['AND'].push({OR: orTitle});
  }
  newQuery.title_exists = true;
  if (calendarReel) {
    newQuery['OR'].push({
      ['AND']: [{releaseDate_gte: calendarReel?.from}, {releaseDate_lte: calendarReel?.to}],
    });
    newQuery['OR'].push({releaseDate_exists: false});
    // newQuery.releaseDate_exists = true;
  }
  newQuery['AND'].push({"languagesPage_not_in": ["Thai","Indo"]})

  let result = {};
  let data_releaseDate_exists_false;
  if (skip === 0) {
    const {
      props: {data: data_releaseDate_exists_false},
    } = await ssrGetListGames.getServerPage(
      {
        variables: {
          locale,
          skip,
          limit: 50,
          where: {...newQuery, OR: [...newQuery['OR'], {releaseDate_exists: false}]},
          order: sort,
        },
      },
      {}
    );
    dataResult = data_releaseDate_exists_false.gameCollection?.items || [];
  }

  const {
    props: {data: data_releaseDate_exists_true},
  } = await ssrGetListGames.getServerPage(
    {
      variables: {
        locale,
        skip,
        limit,
        where: {...newQuery, OR: [...newQuery['OR'], {releaseDate_exists: true}]},
        order: sort,
      },
    },
    {}
  );
  result = {
    ...data_releaseDate_exists_true?.gameCollection,
    items: [...dataResult, ...(data_releaseDate_exists_true?.gameCollection?.items || [])],
    query: {
      data_releaseDate_exists_false: dataResult?.length
    }
  };

  return result as ExtendedGameCollection
}

export default getListGame;
